export function Dot(props: React.SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg width='8' height='8' viewBox='0 0 8 8' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <circle cx='4.00003' cy='4' r='3' fill='currentFill' />
    </svg>
  )
}
